import { inject, injectable } from "inversify";
import { DependencyType } from "@di/DependencyType";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import {
  CreateLaboratoryDocument,
  CreateLaboratoryInput,
  CreateLaboratoryMutation,
  CreateLaboratoryMutationVariables,
  LaboratoriesDocument,
  LaboratoriesQuery,
  LaboratoriesQueryVariables,
} from "generated/graphql";

@injectable()
export class LaboratoryService {
  constructor(
    @inject(DependencyType.ApolloClient)
    private readonly apolloClient: ApolloClient<NormalizedCacheObject>
  ) {}

  async findAll() {
    const queryTuple = await this.apolloClient.query<
      LaboratoriesQuery,
      LaboratoriesQueryVariables
    >({
      query: LaboratoriesDocument,
    });

    if (queryTuple.errors) {
      throw new Error(queryTuple.errors[0].message);
    }

    return queryTuple.data.laboratories;
  }

  async create(input: CreateLaboratoryInput) {
    const mutationTuple = await this.apolloClient.mutate<
      CreateLaboratoryMutation,
      CreateLaboratoryMutationVariables
    >({
      mutation: CreateLaboratoryDocument,
      variables: {
        input,
      },
      refetchQueries: [
        {
          query: LaboratoriesDocument,
        },
      ],
      awaitRefetchQueries: true,
    });

    if (mutationTuple.errors) {
      throw new Error(mutationTuple.errors[0].message);
    }

    return mutationTuple.data?.createLaboratory;
  }
}
